// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.preview-container {
  display: flex;
  flex-direction: column;
  overflow: hidden;
  height: 100%;
  min-height: 0;
}

.loading-state,
.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 16px;
  color: var(--on-surface-variant);
}

.error-state {
  color: var(--error);
}
.error-state mat-icon {
  font-size: 48px;
  width: 48px;
  height: 48px;
}

.image-container {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: auto;
  padding: 16px;
  background: var(--surface-container);
}
.image-container img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.pdf-toolbar {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 8px;
  background: var(--surface-container);
  border-bottom: 1px solid var(--outline-variant);
}
.pdf-toolbar button {
  color: var(--on-surface-variant);
}
.pdf-toolbar button:disabled {
  opacity: 0.4;
}
.pdf-toolbar .zoom-level {
  min-width: 48px;
  text-align: center;
  font-size: 13px;
  color: var(--on-surface);
}
.pdf-toolbar .toolbar-divider {
  width: 1px;
  height: 24px;
  background: var(--outline-variant);
  margin: 0 4px;
}
.pdf-toolbar .toolbar-spacer {
  flex: 1;
}
.pdf-toolbar .page-info {
  font-size: 12px;
  color: var(--on-surface-variant);
  padding-right: 8px;
}

.pdf-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 16px;
  overflow-y: auto;
  min-height: 0;
  background: #525659;
}
.pdf-container canvas {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/strategy-grid/preview-widget/preview-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,YAAA;EACA,aAAA;AACF;;AAEA;;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,SAAA;EACA,gCAAA;AACF;;AAEA;EACE,mBAAA;AACF;AACE;EACE,eAAA;EACA,WAAA;EACA,YAAA;AACJ;;AAGA;EACE,OAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,oCAAA;AAAF;AAEE;EACE,eAAA;EACA,gBAAA;EACA,mBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,oCAAA;EACA,+CAAA;AADF;AAGE;EACE,gCAAA;AADJ;AAGI;EACE,YAAA;AADN;AAKE;EACE,eAAA;EACA,kBAAA;EACA,eAAA;EACA,wBAAA;AAHJ;AAME;EACE,UAAA;EACA,YAAA;EACA,kCAAA;EACA,aAAA;AAJJ;AAOE;EACE,OAAA;AALJ;AAQE;EACE,eAAA;EACA,gCAAA;EACA,kBAAA;AANJ;;AAUA;EACE,OAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,SAAA;EACA,aAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;AAPF;AASE;EACE,wCAAA;EACA,cAAA;AAPJ","sourcesContent":[".preview-container {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n  min-height: 0;\n}\n\n.loading-state,\n.error-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  gap: 16px;\n  color: var(--on-surface-variant);\n}\n\n.error-state {\n  color: var(--error);\n\n  mat-icon {\n    font-size: 48px;\n    width: 48px;\n    height: 48px;\n  }\n}\n\n.image-container {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: auto;\n  padding: 16px;\n  background: var(--surface-container);\n\n  img {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n}\n\n.pdf-toolbar {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  padding: 4px 8px;\n  background: var(--surface-container);\n  border-bottom: 1px solid var(--outline-variant);\n\n  button {\n    color: var(--on-surface-variant);\n\n    &:disabled {\n      opacity: 0.4;\n    }\n  }\n\n  .zoom-level {\n    min-width: 48px;\n    text-align: center;\n    font-size: 13px;\n    color: var(--on-surface);\n  }\n\n  .toolbar-divider {\n    width: 1px;\n    height: 24px;\n    background: var(--outline-variant);\n    margin: 0 4px;\n  }\n\n  .toolbar-spacer {\n    flex: 1;\n  }\n\n  .page-info {\n    font-size: 12px;\n    color: var(--on-surface-variant);\n    padding-right: 8px;\n  }\n}\n\n.pdf-container {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 16px;\n  overflow-y: auto;\n  min-height: 0;\n  background: #525659;\n\n  canvas {\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n    flex-shrink: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
